
import React, { useContext, useEffect, useState } from 'react';
import { StateContext } from './Context';
import './Main.css'

const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
const mic = new SpeechRecognition();

mic.continuous = true;
mic.interimResults = true;
mic.lang = 'en-US';

function Main() {

    const { isMicOnObj, noteObj, savedNotesObj, newNoteObj, titleObj, showTitleObj, savedTitlesObj } = useContext(StateContext);
    const [isMicOn, setIsMicOn] = isMicOnObj;
    const [note, setNote] = noteObj;
    const [savedNotes, setSavedNotes] = savedNotesObj;
    const [savedTitles, setSavedTitles] = savedTitlesObj;

    const [newNote, setNewNote] = newNoteObj;
    const [title, setTitle] = titleObj;
    const [showTitle, setShowTitle] = showTitleObj;


    const [showSubmitButton, setShowSubmitButton] = useState(true)

    useEffect(() => {
        handleListen()
    }, [isMicOn])

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const handleListen = () => {
        if (isMicOn) {
            mic.start()
            mic.onend = () => {
                console.log('continue..');
                mic.start()
            }
        }

        else {
            mic.stop()
            mic.onend = () => {
                console.log('Stopped mic on CLick');

            }
        }

        mic.onstart = () => {
            console.log('Mics On');
        }

        mic.onresult = event => {
            const transcript = Array.from(event.results)
                .map(result => result[0])
                .map(result => result.transcript)
                .join('')

            // console.log(transcript);
            setNote(capitalizeFirstLetter(transcript));

            mic.onerror = event => {
                console.log(event.error);
            }
        }
    }

    const handleSaveNote = () => {
        setSavedNotes([...savedNotes, { note: note }])
        setSavedTitles([...savedTitles, { title: title }])
        setNote('')
        setShowTitle(false)
        setTitle('')
        setShowSubmitButton(true)
    }

    const createNewNote = () => {
        setNewNote(prev => !prev)
    }

    const onTitleSubmit = (e) => {
        e.preventDefault()
        setShowTitle(true)
        setShowSubmitButton(false)
    }

    return (
        <div>
            <div className="box audio-box">
                <h2>YOUR CURRENT NOTE</h2>
                <hr className="hr-app" />
                {isMicOn ?
                    <span><i className="fas fa-microphone"></i></span>
                    :
                    <span><i className="fas fa-microphone-slash"></i></span>
                }

                {showTitle ? <button className="start-stop-button" onClick={() => setIsMicOn(prevState => !prevState)} >Start/Stop</button> : ''}



                {showSubmitButton ? <button onClick={createNewNote} className="create-button" >Create Note</button> : ''} <br />

                <form onSubmit={onTitleSubmit}>

                    <div>
                        {newNote && showSubmitButton ? <input value={title} onChange={(e) => setTitle(e.target.value)} /> : ''}
                        {newNote && showSubmitButton && title ? <button className="submit-button" type="submit" >Submit</button> : ''}
                    </div>
                </form>

                {showTitle ? <h4>{title}</h4> : ''}

                <p>{note}</p>

                {note && !isMicOn ? <button className="save-button" onClick={handleSaveNote}  >Save Note</button> : ''}
            </div>
        </div>
    )
}

export default Main
